import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-arrow-alt-circle-up" }, null, -1)
const _hoisted_2 = [
  _hoisted_1
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    id: "sx_scrolltop",
    ref: "sx_scrolltop",
    class: _normalizeClass(["scrolltop", { 'sx-list-scroll-top': _ctx.$route.meta.isListPage }]),
    "data-sx-scrolltop": "true"
  }, _hoisted_2, 2))
}